import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "21340a0c-f2ff-4764-87d0-384a83c1b3c1",
    content: "Large rooms",
    options: {},
  },
  {
    id: "1491588d-64ea-4c48-9a15-924db012522d",
    content: "Concrete walls",
    options: {},
  },
  {
    id: "880c3b16-73bd-417a-a9a3-3d644a360e00",
    content: "Empty rooms",
    options: {},
  },
  {
    id: "142933b7-bf6a-4f12-8b61-a81698cf4d59",
    content: "Big windows",
    options: {},
  },
  {
    id: "34f9fa17-c85b-47f5-adf8-fe55a23285d9",
    content: "Small rooms",
    options: {},
  },
  {
    id: "6b81aed8-f125-48dd-9be0-276d9ff5ccd6",
    content: "Porous materials",
    options: {},
  },
  {
    id: "0b98c30e-e04c-4163-85e9-1d6bd6aaed3a",
    content: "Furnished rooms",
    options: {},
  },
  {
    id: "4b06e8d1-975b-42da-9998-77eb0aedc929",
    content: "Carpet covered surfaces",
    options: {},
  },
];

const groups = [
  {
    id: "be30c695-fd3e-43dc-ba18-2cc54388b6f9",
    content: "Longer reverberation times",
    options: {},
  },
  {
    id: "d0e180c3-db07-4264-9ad9-c919b3001d6a",
    content: "Shorter reverberation times",
    options: {},
  },
];

export const task: Task = {
  id: "be30c695-fd3e-43dc-ba18-2cc54388b6f9",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    orientation: "vertical",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "be30c695-fd3e-43dc-ba18-2cc54388b6f9",
      itemsId: [
        "21340a0c-f2ff-4764-87d0-384a83c1b3c1",
        "1491588d-64ea-4c48-9a15-924db012522d",
        "880c3b16-73bd-417a-a9a3-3d644a360e00",
        "142933b7-bf6a-4f12-8b61-a81698cf4d59",
      ],
    },
    {
      groupId: "d0e180c3-db07-4264-9ad9-c919b3001d6a",
      itemsId: [
        "34f9fa17-c85b-47f5-adf8-fe55a23285d9",
        "6b81aed8-f125-48dd-9be0-276d9ff5ccd6",
        "0b98c30e-e04c-4163-85e9-1d6bd6aaed3a",
        "4b06e8d1-975b-42da-9998-77eb0aedc929",
      ],
    },
  ],
};
